import {FETCH_LANDING} from "../types";


export const initialState = {
    entities: [],
};

export default function landingReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_LANDING:
            return {
                ...state,
                data: action.payload
            };
        default:
            return state;
    }
};
